import Component from 'vue-class-component';

// Register hooks for all components
Component.registerHooks(['beforeRouteLeave']);
